import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import ApiService from '@/core/services/ApiService';
import { StoreModel } from '@/assets/ts/_utils/models/StoreModel';
import { domainUrlAdmin } from '@/core/config/DomainConfig';
import { ErrorGetters } from '@/store/enums/ErrorGettersEnums';

@Module({ name: 'AdminPriceplanModule' })
export default class AdminPriceplanModule extends VuexModule implements StoreModel {
  errors = {};

  /**
   * Get  errors
   * @returns array
   */
  get [ErrorGetters.GET_ERRORS_ADMIN_PRICEPLAN]() {
    return this.errors;
  }
  @Mutation
  [Mutations.CLEAR_STORE]() {
    this.errors = {};
  };

  @Mutation
  [Mutations.SET_ERROR_PRICEPLAN](error) {
    this.errors = { ...error };
  }

  @Action
  [Actions.SYNC_USER_PRICETAGS](data) {
    return ApiService.post(`${domainUrlAdmin}priceplans/pricetags/user/${data.id}/sync`, data.params)
      .then(({ data }) => {
        console.log(data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR_PRICEPLAN, response?.data?.errors);
      });
  }
}
